export const DOMAIN_URL = 'https://sensormaticapi.fbox.uz'
// export const DOMAIN_URL = 'http://127.0.0.1:8000'
export const API_URL = `${DOMAIN_URL}/api/v1/`

const LOGIN = 'login'
export const SIGN_IN = `${LOGIN}/`

const MARKET_STATS = 'market'
export const MARKET_STATS_LIST = `${MARKET_STATS}/`
